import { render, staticRenderFns } from "./demand-publish.vue?vue&type=template&id=499c5fbd&scoped=true"
import script from "./demand-publish.vue?vue&type=script&lang=js"
export * from "./demand-publish.vue?vue&type=script&lang=js"
import style0 from "./demand-publish.vue?vue&type=style&index=0&id=499c5fbd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499c5fbd",
  null
  
)

export default component.exports